module.exports = __webpack_public_path__ + "static/media/arrow_right.8802bcd2.png";